import gql from 'graphql-tag'

export const GET_INSTITUTIONS = gql`
  query {
    instituicoes {
      _id
      nome
    }    
  }
`

export const GET_EXAMS = gql`
  query {
    provas {
      _id
      ano
      descricao
      instituicao {
        _id
        nome
      }
    }
  }
`

export const GET_SIMULATEDLIST = gql`
  query {
    simulados {
      _id
      ano
      descricao
      instituicao {
        _id
        nome
      }
    }
  }
`

export const GET_EXAM = gql`
  query prova($_id: String!){
    prova(_id: $_id) {
      instituicao {
        nome
      }
      ano
      descricao
      perguntas {
        numero
        enunciado
        comentario
        questao_anulada
        _id
        dificuldade {
          label
        }
        disciplina { 
          nome
        }
        respostas {
          _id
          resposta
          numero
        }
      }
    }
  }
`

export const GET_CUSTOM_EXAM = gql`
  query provaPersonalizada($_id: String!){
    provaPersonalizada(_id: $_id) {
      anos
      instituicoes
      especialidades
      dificuldades
      quantidadeDePerguntas
      perguntasAleatorias
      respostasAleatorias
      perguntas {
        enunciado
        comentario
        prova {
          descricao
          ano
          instituicao {
            nome
          }
        }
        _id
        disciplina {
          nome
        }
        dificuldade {
          label
        }
        respostas {
          _id
          resposta
          numero
        }
      }
    }
  }
`

export const GET_SIMULATED = gql`
  query simulado($_id: String!){
    simulado(_id: $_id) {
      descricao
      perguntas {
        enunciado
        comentario
        _id
        prova{
          descricao
        }
        dificuldade {
          label
        }
        respostas {
          _id
          resposta
          numero
        }
      }
    }
  }
`

export const GET_SPECIALIZATION = gql`
  query {
    especialidades {
      _id
      nome
    }
  }
`

export const GET_DIFFICULTY = gql`
  query {
    dificuldades {
      _id
      nome
      valor
      label
    }
  }
`

export const GET_YEARS = gql`
  query {
    anos {
      _id
      ano
    }
  }
`

export const GET_EXAM_RESULT = gql`
query feedbackExame($_id: String!) {
  feedbackExame(_id: $_id) {
    score,
    totalDePerguntas,
    totalDePerguntasCorretas,
    tipo,
    descricao,
    ano,
    isProvaPersonalizada
    provaPersonalizada {
      anos
      dificuldades
      especialidades
      instituicoes
      quantidadeDePerguntas
      perguntasAleatorias
      respostasAleatorias
    }
    usuario { 
      nome
    },
    dataRealizacao,
    instituicao {
      _id,
      nome
    },
    porcentagemPorDisciplina {
      pontos
      disciplina
      respostasCorretas
      questoesDisciplina
    },
    perguntas {
      enunciado,
      respostaCorreta {
      	_id,
        numero,
        resposta
      },
      respostaAssinalada {
      	_id,
        numero,
        resposta
      },
      anulada,
      respondida,
      correta,
      comentario
    }
  }
}
`
export const GET_DATE_START = gql`
  query {
    dataInicio
  }
`